

import escalationTypesReducer from './EscalationTypesReducer'
export { escalationTypesReducer }

export * from './EscalationTypesActions'



// WEBPACK FOOTER //
// ./src/store/escalation-types/index.js